import React from "react";
import AqContainer from "./../containers/AqContainer";

function FormAQ() {
  return <AqContainer></AqContainer>;
}

export default FormAQ;
